import React from 'react';
import Box from '@mui/material/Box';
import StatusChip from './StatusChip';
import { AWAITING_DEPLOY, ITEM_STATUS } from '../changelogAdminConfig';

/**
 * Status da novidade (Rascunho, Publicado, Interno) e, quando for o caso, "Aguardando deploy".
 * @param {{ item: Object }} props
 */
function ItemStatusChips({ item }) {
  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      <StatusChip info={ITEM_STATUS[item.status] || ITEM_STATUS.draft} />
      {item.awaiting_deploy && <StatusChip info={AWAITING_DEPLOY} />}
    </Box>
  );
}

export default ItemStatusChips;
